import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const MonthlyRevenueChart = ({ data, selectedPeriod, showNet = false }) => {
  const formatCurrency = (value) => {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })?.format(value);
  };

  const formatMonth = (monthNumber) => {
    const months = [
      'Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun',
      'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'
    ];
    return months[monthNumber - 1] || monthNumber;
  };

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload?.length) {
      const monthName = formatMonth(label);
      return (
        <div className="bg-popover border border-border rounded-lg p-3 shadow-modal">
          <p className="font-medium text-popover-foreground mb-2">{monthName}</p>
          <div className="space-y-1">
            <div className="flex items-center justify-between space-x-4">
              <span className="text-sm text-text-secondary">Gesamtumsatz:</span>
              <span className="font-medium text-primary">{formatCurrency(payload?.[0]?.value)}</span>
            </div>
            {showNet && (
              <div className="flex items-center justify-between space-x-4">
                <span className="text-sm text-text-secondary">Nettoumsatz:</span>
                <span className="font-medium text-text-secondary">{formatCurrency(payload?.[0]?.value / 1.19)}</span>
              </div>
            )}
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
                     <h2 className="text-xl font-semibold text-text-primary">Monatlicher Umsatz</h2>
             <div className="text-sm text-text-secondary">
               Jahr: {selectedPeriod}
             </div>
      </div>
      
      <div className="h-96">
        <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          layout="vertical"   // 👈 this is important for horizontal bars
          margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
          <XAxis type="number" tickFormatter={formatCurrency} stroke="var(--color-text-secondary)" />
          <YAxis type="category" dataKey="month" tickFormatter={formatMonth} stroke="var(--color-text-secondary)" />
          <Tooltip content={<CustomTooltip />} />
          <Bar dataKey="revenue" fill="var(--color-success)" radius={[0, 4, 4, 0]} />
        </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default MonthlyRevenueChart;
